import React, { useEffect } from "react";
import dynamic from "next/dynamic";
const CareerBanner = dynamic(() => import("./career-banner"),{ssr: true});
const CareerInsights = dynamic(() => import("./career-insights"), {
  ssr: true,
});
const CareerExplore = dynamic(() => import("./career-explore"), { ssr: true });
const CareerFind = dynamic(() => import("./career-find"), { ssr: true });
const CareerPlace = dynamic(() => import("./career-place"), { ssr: true });
const CareerBenefit = dynamic(() => import("./career-benefit"), { ssr: true });
const CareerPromises = dynamic(() => import("./career-promises"), {
  ssr: true,
});

interface CareerProps {
  blocks?: any;
  data?: any;
  referer: string;
  isMobile?: boolean;
  listData?: any[];
}

const CareerPage: React.FC<CareerProps> = ({
  blocks,
  referer,
  listData,
  isMobile = false,
}) => {
  const [isKill, setIsKill] = React.useState(false);
  useEffect(() => {
    if (!referer?.includes("contact-us")) {
      if (!!sessionStorage.getItem("hdd-referer"))
        sessionStorage.removeItem("hdd-referer");
      sessionStorage.setItem("hdd-referer", referer);
    }
  }, [referer]);
  useEffect(() => {
    if (isKill)
      setTimeout(() => {
        setIsKill(false);
      }, 2000);
  }, [isKill]);

  return (
    <>
      <div className="nome-new rfp_new bg-one">
        {blocks?.map((block: any, i: number) => {
          switch (block?.__component) {
            case "blocks.2025-career-banner":
              return <CareerBanner key={i} data={block} isMobile={isMobile} />;
            case "blocks.2025-career-great-place-to-work":
              return <CareerPlace key={i} data={block} />;
            case "blocks.2025-testimonials":
              return (
                <CareerInsights key={i} data={block} isMobile={isMobile} />
              );
            case "blocks.career-open-positions":
              return (
                <CareerExplore
                  key={i}
                  data={block}
                  isMobile={isMobile}
                  listData={listData ?? []}
                  handleSwitch={() => setIsKill(true)}
                />
              );
            case "blocks.career-desire-position":
              return <CareerFind key={i} data={block} />;
            case "blocks.career-our-promises":
              return <CareerPromises key={i} data={block} isKill={isKill} />;
            case "blocks.career-perks-and-benefits":
              return <CareerBenefit key={i} data={block} />;
            default:
              return (
                <div
                  key={i}
                  className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                >
                  Unknown block type: {block?.__component || "undefined"}
                </div>
              );
          }
        })}
      </div>
    </>
  );
};

export default CareerPage;
